export const hasHTML = (str: string) => /<[^>]+>/.test(str);
